export default __webpack_public_path__ + "static/media/img1.4a31ba08.jpg";